/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useProduct = () => {
  const [host, product, prodId] = window.location.pathname.split("/");
  const urlParams = new URLSearchParams(window.location.search);
  let auth = urlParams.get("auth");

  return {
    prodId: prodId,
    auth:auth
  };
};
